<template>
  <div :class='isNew ? "brokerage-house single" : "brokerage-house"'>
    <div class="column has-text-left box">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteBrokerageHouse(houseObject.id)" v-if="!isNew"/>
      <b-field label="Заголовок">
        <b-input v-model='houseObject.title'></b-input>
      </b-field>
      <b-field label="Ссылка">
        <b-input v-model='houseObject.url'></b-input>
      </b-field>
      <b-switch v-model='houseObject.isHidden'>Cкрыть с сайта</b-switch> <br>
      <b-field label="Логотип" class="logo-wrapper mt-10">
        <img :src="imageUrl" v-if="imageUrl" class="logo">
        <span class="button-wrapper" @click="$refs.loadLogoInput.click()" v-if="!imageUrl">
          <a class="button is-info">+</a>Добавить
        </span>
        <span class="button-wrapper" @click="removeImage" v-else>
          <a class="button is-danger">-</a>Удалить
        </span>
        <input type="file" @change='loadLogo' hidden ref="loadLogoInput"/>
      </b-field>
      <button class="button is-primary mt-10 save-button" @click="save" :disabled="disabled">СОХРАНИТЬ</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'BrokerageHouseItem',
  data () {
    return {
      imageSrc: '',
      disabled: false,
      houseObject: null
    }
  },
  computed: {
    imageUrl () {
      const originalLogo = this.houseObject && this.houseObject.logo ? this.houseObject.logo.image : ''
      return this.imageSrc || (originalLogo ? `/upload/photos/${originalLogo}` : '')
    },
    isNew () {
      return this.$route.name === 'BrokerageHouseCreator'
    }
  },
  props: {
    house: { }
  },
  created () {
    this.houseObject = deepcopy(this.house || {
      url: '',
      title: '',
      isHidden: true,
      logo: {
        image: '',
        orientation: ''
      }
    })
  },
  methods: {
    ...mapActions(['updateBrokerageHouse', 'deleteBrokerageHouse']),
    save () {
      if (this.houseObject.title || this.houseObject.url) {
        this.disabled = true
        let data = new FormData()
        data.append('data', JSON.stringify(this.houseObject))
        data.append('image', this.houseObject.logo.image)
        this.updateBrokerageHouse(data)
        .then(() => {
          this.disabled = false
          this.$router.push({ name: 'BrandRecommendations' })
          this.$toast.open({
            message: 'Сохранено'
          })
        })
      } else {
        this.$toast.open({
          message: 'Заполните хотя бы одно поле',
          type: 'is-danger'
        })
      }
    },
    removeImage () {
      this.imageSrc = ''
      this.houseObject.logo = {
        orientation: '',
        image: ''
      }
      this.$refs.loadLogoInput.value = ''
    },
    loadLogo (e) {
      const reader = new FileReader()
      reader.onload = e => {
        this.imageSrc = e.target.result
        const image = new Image()
        image.src = e.target.result
        image.onload = () => {
          this.houseObject.logo.orientation = (image.width / image.height <= 2.5) ? 'vertical' : 'horizontal'
        }
      }
      this.houseObject.logo.image = e.target.files[0]
      reader.readAsDataURL(e.target.files[0])
    }
  }
}
</script>

<style scoped>
.main-content .logo-wrapper {
  display: block !important;
}
.logo {
  display: block;
  max-height: 200px;
}
.brokerage-house.single {
  max-width: 760px;
  margin: 0 auto;
}
.brokerage-house .delete-icon {
  right: 9px;
  top: -13px;
}
.save-button {
  display: block;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// BrokerageHouseItem.vue?351cc126